import React from 'react';
import {
	ToolbarSkeleton,
	type SkeletonToolbarProps,
} from '@atlassian/jira-floating-toolbar/src/ui/skeleton/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { expVal } from '@atlassian/jira-feature-experiments';
import { messages as changeStatusMessages } from '../use-status-action/messages.tsx';
import { messages as editButtonMessages } from '../use-edit-action/messages.tsx';
import { messages as deleteButtonMessages } from '../bulk-delete/messages.tsx';
import { messages as watchOptionsButtonMessages } from '../use-watch-action/messages.tsx';

export const BulkOperationsToolbarSkeleton = ({
	hasSelectAllButton,
	buttons,
}: SkeletonToolbarProps) => {
	const { formatMessage } = useIntl();

	const allButtons: SkeletonToolbarProps['buttons'] = [
		{
			text: formatMessage(editButtonMessages.editButton),
			hasIcon: true,
		},
		{
			text: formatMessage(changeStatusMessages.changeStatus),
			hasIcon: true,
		},
		...(expVal('bulk_delete_experiment', 'isEnabled', false)
			? [
					{
						text: formatMessage(deleteButtonMessages.deleteButton),
						hasIcon: true,
					},
				]
			: []),
		...(expVal('bulk_watch_unwatch', 'isEnabled', false)
			? [
					{
						text: formatMessage(watchOptionsButtonMessages.watchOptions),
						hasIcon: true,
					},
				]
			: []),
		...buttons,
	];

	return <ToolbarSkeleton hasSelectAllButton={hasSelectAllButton} buttons={allButtons} />;
};
